import { LOGIN_STUDIO, LOGOUT_ARTIST } from "../auth/authActions";
import { LOAD_LOGGED_ARTIST_SETTINGS_SUCCESS } from "../common/commonActions";
import { DELETE_KUNDE, SAVE_KUNDE } from "../kunde/kundeAction";
import { MERGE_DOUBLETS } from "../list/listActions";
import {
    replacePayloadFields
} from "../utils/reducerUtils";
import {
    CHANGE_CALENDAR_EVENT_FILTER,
    CHANGE_CALENDAR_SELECTED_LOCATION,
    CHANGE_CALENDAR_SELECTED_TERMIN_WITH_CONTEXT,
    CHANGE_CALENDER_SELECTED_KUND_ID,
    CLEAR_CALENDAR_SELECTED_TERMIN_ID,
    SET_CALENDAR_CUSTOMER_SEARCH_STATE,
    CLEAR_CALENDAR_CUSTOMER_SEARCH_STATE,
} from "./calendarActions";


// View type constants - exported for use in selectors (they check viewType values, not Redux state)
export const SINGLE_ARTIST_VIEW = "singleArtist";
export const MULTIPLE_ARTIST_VIEW = "multipleArtists";
export const MONTH_VIEW = "dayGridMonth";

const INITIAL = {
    /**
     * Customer search UI state (non-shareable, UI-only).
     * Server-side search results remain in TanStack Query.
     */
    customerSearchState: {
        searchString: "",
        settings: {},
        selectedSearchedKundId: null,
    },
};

export default function calendarReducer(state = INITIAL, action) {
    switch (action.type) {
        case LOGOUT_ARTIST:
        case LOGIN_STUDIO:
            return { ...INITIAL };
        case LOAD_LOGGED_ARTIST_SETTINGS_SUCCESS:
            return {
                ...state,
                resourceFilter: action.payload.artistSettings?.resourceFilter,
                eventFilter: action.payload.artistSettings?.eventFilter,
            };

        case CLEAR_CALENDAR_SELECTED_TERMIN_ID:
            return {
                ...state,
                selectedTerminID: undefined,
                selectedTerminProjekt: undefined,
                selectedTerminContext: undefined,
            };

        case CHANGE_CALENDAR_SELECTED_LOCATION:
            return {
                ...state,
                resourceFilter: {
                    ...state.resourceFilter,
                    tatortId: action.payload.tatortId,
                },
            };

        case CHANGE_CALENDAR_SELECTED_TERMIN_WITH_CONTEXT: {
            const { terminId, kundId, context } = action.payload.selection || {};
            return {
                ...state,
                selectedTerminID: terminId,
                selectedKundID: kundId ?? state.selectedKundID,
                selectedTerminProjekt: undefined,
                selectedTerminContext: context,
            };
        }

        case MERGE_DOUBLETS:
            return {
                ...state,
                selectedKundID:
                    state.selectedKundID !== +action.payload?.mergeData?.kundIdFrom ? state.selectedKundID : undefined,
            };

        case SAVE_KUNDE:
            return {
                ...state,
                selectedKundID: action.payload?.saveKundeData?.kunde
                    ? action.payload?.saveKundeData?.kunde.KundID
                    : state.selectedKundID,
            };
        case DELETE_KUNDE:
            return {
                ...state,
                selectedKundID: undefined,
            };

        case SET_CALENDAR_CUSTOMER_SEARCH_STATE: {
            const changes = action.payload.customerSearchState || {};
            return {
                ...state,
                customerSearchState: {
                    ...state.customerSearchState,
                    ...changes,
                },
            };
        }

        case CLEAR_CALENDAR_CUSTOMER_SEARCH_STATE:
            return {
                ...state,
                customerSearchState: { ...INITIAL.customerSearchState },
            };

        case CHANGE_CALENDAR_EVENT_FILTER:
        case CHANGE_CALENDER_SELECTED_KUND_ID:
            return replacePayloadFields(state, action);

        default:
            return state;
    }
}
